import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../common/html/element'
import { Loading } from '../../../common/loading'
import {
  BLOCK_TYPE,
  factSheetTypes,
} from '../../../common/order/factSheetReport/constants'
import { FactSheetContent } from '../../../common/order/factSheetReport/factSheetContent'
import {
  changeFsType,
  changeSource,
  resetStore,
  selectData,
  selectDataAvailabilityDetails,
  selectFactSheetChecked,
  selectFsType,
  selectIsLoading,
  selectSource,
  selectSources,
} from '../../../common/order/factSheetReport/store/slice'
import {
  getDataAvailability,
  getReportItem,
} from '../../../common/order/factSheetReport/store/thunk'
import { addToCart } from '../../../common/order/popup/popupConfirmationBuyNowOrAddCart/store/thunk'
import { PopupAction } from '../../../common/popup/PopupAction'
import { formatText } from '../../../helpers/value'
import { selectUserType } from '../../../layout/store/slice'
import { USER_TYPE } from '../../../utils/authorization'
import { LANGUAGE_SELECT } from '../../constant'
import { getActiveItemUnit, handelDataGetDataAvailability } from '../../helper'
import {
  changeDefaultFormFactSheet,
  changeFragment,
  getDefaultFormFactSheet,
  selectFactSheetDetail,
} from '../../store/slice'
import { SubCriteriaFactSheet } from './SubCriteriaFactSheet'

export const ChangeFactSheetReport = ({ isShow, onClose, data }) => {
  const dispatch = useDispatch()

  const languageDefault = data?.language
  const currencyCode = data.currency
  const currencyUnit = data.unit
  const currentAdditional = data?.additionalCurrency
  const unitAdditional = data?.additionalUnit

  const detail = useSelector(selectFactSheetDetail(data.id))
  const userType = useSelector(selectUserType)
  const isLoading = useSelector(selectIsLoading)
  const dataForm = useSelector(selectData)
  const checked = useSelector(selectFactSheetChecked)
  const source = useSelector(selectSource)
  const sources = useSelector(selectSources)

  const fsType = useSelector(selectFsType)
  const dataAvailabilities = useSelector(selectDataAvailabilityDetails)
  const { language, currency, unit, currencyFS, unitFS } = useSelector(
    getDefaultFormFactSheet,
  )

  const type = [USER_TYPE.LITE, USER_TYPE.BASIC].includes(userType.userTypeId)
    ? factSheetTypes.POPUP_LITE
    : factSheetTypes.POPUP_OTHERS

  const onSubmit = () => {
    const { reportingDate } =
      dataForm?.dataBlocks.find((item) => item.id === BLOCK_TYPE.SCORE) || {}

    dispatch(
      addToCart({
        cartItems: [
          {
            id: data?.id,
            fiinGateReportTypeId: dataForm.fiinGateReportTypeId,
            organizationId: dataForm.organizationId,
            availableData: dataForm.availableData,
            dataBlocks: Object.keys(checked)
              .filter((id) => checked[id])
              .map((id) => {
                switch (+id) {
                  case BLOCK_TYPE.FINANCIAL_STATEMENT:
                    return {
                      dataBlockId: +id,
                      reportSourceId: sources.find(
                        (item) => item?.sourceOrganizationId === source,
                      ).id,
                      consolidated: fsType,
                      dataAvailabilities: dataAvailabilities.map((item) => ({
                        year: item.year,
                        audited: item.audited,
                        isDirect: item.isDirect,
                        available: item.available,
                      })),
                    }

                  case BLOCK_TYPE.SCORE:
                    return {
                      dataBlockId: +id,
                      reportingDate,
                    }

                  default:
                    return {
                      dataBlockId: +id,
                    }
                }
              }),
            languageCode: language?.value,
            currencyCode: currency?.value,
            currencyUnit: unit?.value,
            additionalCurrencyCode: currencyFS?.value,
            additionalCurrencyUnit: unitFS?.value,
          },
        ],
      }),
    )
      .unwrap()
      .then(() => {
        dispatch(changeFragment())
        onClose()
      })
      .catch(() => {})
  }

  useEffect(() => {
    dispatch(
      getReportItem({
        OrganizationId: data.organizationId,
      }),
    )
    dispatch(
      changeDefaultFormFactSheet({
        language: languageDefault
          ? LANGUAGE_SELECT.find(
              (item) =>
                item.value?.toLowerCase() === languageDefault?.toLowerCase(),
            )
          : {},
        currency: { label: currencyCode, value: currencyCode },
        unit: getActiveItemUnit(currencyUnit),
        currencyFS: currentAdditional
          ? { label: currentAdditional, value: currentAdditional }
          : {},
        unitFS: getActiveItemUnit(unitAdditional),
      }),
    )

    return () => {
      dispatch(resetStore())
    }
  }, [])

  useEffect(() => {
    dispatch(
      getDataAvailability({
        organizationId: data.organizationId,
        sourceOrganizationId: sources.find(
          (item) => item?.id === detail.sourceId,
        )?.sourceOrganizationId,
        isConsolidated: detail?.consolidated,
        auditStatuses: handelDataGetDataAvailability(
          detail?.auditStatuses,
          'isAudit',
        ),
        methods: handelDataGetDataAvailability(detail?.methods, 'isDirect'),
        years: detail?.years,
      }),
    )
    dispatch(
      changeSource(
        sources.find((item) => item?.id === detail?.sourceId)
          ?.sourceOrganizationId,
      ),
    )
    dispatch(changeFsType(detail?.consolidated))
  }, [sources])

  return (
    <>
      <PopupAction
        appendStyle={{
          padding: 20,
          backgroundColor: '#F3F3F3',
          width: 930,
          borderRadius: '4px',
        }}
        isShow={isShow}
        title="cartAndOrders.main.variations"
        handleClose={onClose}
        btnSubmit={{
          label: 'cartAndOrders.tradeDiscount.apply',
          event: onSubmit,
          isI18n: true,
        }}
        btnCancel={{
          label: 'cartAndOrders.tradeDiscount.cancel',
          event: onClose,
          isI18n: true,
        }}
      >
        {!isLoading ? (
          <>
            <Element className="fw600 py1" style={{ fontSize: 14 }}>
              FiinGate Factsheet
            </Element>
            <Element
              className="fw600 py1"
              style={{ color: '#0553A5', paddingTop: 12 }}
            >
              {formatText(data?.companyName)}
            </Element>
            <Element className="pb2">
              <Translate
                value={
                  type === factSheetTypes.POPUP_OTHERS
                    ? 'common.order.factSheet.FS_SETTINGS'
                    : 'cartAndOrders.cart.dataBlocks'
                }
                className="fw600"
              />
            </Element>
            <div
              style={{
                paddingLeft: type === factSheetTypes.POPUP_OTHERS ? 0 : 20,
              }}
            >
              <FactSheetContent
                type={type}
                orgId={data.organizationId}
                isHiddenPrice={true}
              />
            </div>
            <div style={{ marginTop: 12 }}>
              <SubCriteriaFactSheet
                data={data}
                language={language}
                currency={currency}
                unit={unit}
                currencyFS={currencyFS}
                unitFS={unitFS}
              />
            </div>
          </>
        ) : (
          <div style={{ height: 100 }}>
            <Loading />
          </div>
        )}
      </PopupAction>
    </>
  )
}
